const BRAND_FONT_LIST_ID = 'brand-font-list';
const BRAND_FONT_OPTION_PREFIX = 'brand-font-option-';
const DOCUMENT_FONT_LIST_ID = 'document-font-list';
const DOCUMENT_FONT_OPTION_PREFIX = 'document-font-option-';
const OPTION_CONTAINER_ID = 'select-list-box';

export {
  BRAND_FONT_LIST_ID,
  BRAND_FONT_OPTION_PREFIX,
  DOCUMENT_FONT_LIST_ID,
  DOCUMENT_FONT_OPTION_PREFIX,
  OPTION_CONTAINER_ID,
};
